import React from 'react';
import { TrendingFlat as ArrowRightIcon } from '@mui/icons-material';
import { Box, Button, Paper, Typography, useTheme } from '@mui/material';

interface RulesSummaryCardProps {
  label: string;
  value: string | number;
  onViewAll?: () => void;
}

export const RulesSummaryCard: React.FC<RulesSummaryCardProps> = ({
  label,
  value,
  onViewAll,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.secondary, fontWeight: 500, mb: 0.5 }}
      >
        {label}
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        {value}
      </Typography>

      <Box sx={{ mt: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          variant="contained"
          size="small"
          onClick={onViewAll}
          sx={{
            bgcolor: '#2D336B', // Based on image
            textTransform: 'none',
            borderRadius: '8px',
            fontSize: '0.75rem',
            px: 2,
            '&:hover': {
              bgcolor: '#1E2248',
            },
          }}
        >
          View All
        </Button>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 24,
            height: 24,
            borderRadius: '50%',
            border: `1px solid ${theme.palette.divider}`,
            color: theme.palette.text.secondary,
            ml: 'auto',
          }}
        >
          <ArrowRightIcon sx={{ fontSize: 16 }} />
        </Box>
      </Box>
    </Paper>
  );
};

